import React from 'react';

const baseProps = {
  viewBox: '0 0 20 20',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
};

function svg(children) {
  return function Icon(props) {
    return (
      <svg {...baseProps} {...props}>
        {children}
      </svg>
    );
  };
}

export const GlobeIcon = svg(
  <>
    <circle cx="10" cy="10" r="7.5" />
    <path d="M2.5 10h15" />
    <path d="M10 2.5c2 2.5 2 12.5 0 15" />
    <path d="M10 2.5c-2 2.5-2 12.5 0 15" />
  </>
);

export const FocusIcon = svg(
  <>
    <rect x="3" y="3" width="14" height="14" rx="2" />
    <path d="M7 10h6" />
    <path d="M10 7v6" />
  </>
);

export const LinkIcon = svg(
  <>
    <path d="M7 12.5l-1.6 1.6a3 3 0 01-4.2-4.2L2.8 8.3a3 3 0 014.2-4.2L8.6 5.7" />
    <path d="M13 7.5l1.6-1.6a3 3 0 014.2 4.2l-1.6 1.6a3 3 0 01-4.2 4.2L11.4 14.3" />
    <path d="M7 13l6-6" />
  </>
);

export const DyslexiaIcon = svg(
  <>
    <text x="10" y="13" textAnchor="middle" fontSize="9" fontWeight="700" fontFamily="serif" fill="currentColor" stroke="none">Dx</text>
  </>
);

export const SpacingIcon = svg(
  <>
    <path d="M3 5h14" />
    <path d="M3 15h14" />
    <path d="M10 5v10" />
    <path d="M6 8l-1 2 1 2" />
    <path d="M14 8l1 2-1 2" />
  </>
);

export const LineHeightIcon = svg(
  <>
    <path d="M5 3v14" />
    <path d="M3 5l2-2 2 2" />
    <path d="M3 15l2 2 2-2" />
    <path d="M10 4h7" />
    <path d="M10 10h7" />
    <path d="M10 16h7" />
  </>
);

export const WeightIcon = svg(
  <>
    <text x="10" y="14" textAnchor="middle" fontSize="11" fontWeight="900" fontFamily="sans-serif" fill="currentColor" stroke="none">B</text>
  </>
);

export const DarkContrastIcon = svg(
  <>
    <path d="M15.5 10a7.5 7.5 0 11-7.5-7.5 5.5 5.5 0 007.5 7.5z" fill="currentColor" stroke="none" />
  </>
);

export const LightContrastIcon = svg(
  <>
    <circle cx="10" cy="10" r="3.5" />
    <path d="M10 2v2" />
    <path d="M10 16v2" />
    <path d="M2 10h2" />
    <path d="M16 10h2" />
    <path d="M4.2 4.2l1.4 1.4" />
    <path d="M14.4 14.4l1.4 1.4" />
    <path d="M4.2 15.8l1.4-1.4" />
    <path d="M14.4 5.6l1.4-1.4" />
  </>
);

export const HighContrastIcon = svg(
  <>
    <path d="M10 2.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15z" />
    <path d="M10 2.5a7.5 7.5 0 010 15" fill="currentColor" stroke="none" />
  </>
);

export const HighSatIcon = svg(
  <>
    <circle cx="10" cy="10" r="7" />
    <path d="M10 3a7 7 0 010 14" fill="currentColor" stroke="none" />
    <path d="M10 3a7 7 0 000 14" fill="currentColor" stroke="none" />
  </>
);

export const LowSatIcon = svg(
  <>
    <circle cx="10" cy="10" r="7" />
    <path d="M10 3v14" />
    <path d="M3 10h14" />
  </>
);

export const MonochromeIcon = svg(
  <>
    <rect x="3" y="3" width="14" height="14" rx="2" fill="currentColor" stroke="none" />
    <text x="10" y="13" textAnchor="middle" fontSize="8" fontWeight="700" fontFamily="sans-serif" fill="#FFFFFF" stroke="none">M</text>
  </>
);

export const ReadingGuideIcon = svg(
  <>
    <path d="M3 9h14" />
    <path d="M3 11h14" />
    <path d="M5 7v6" />
    <path d="M15 7v6" />
  </>
);

export const StopIcon = svg(
  <>
    <rect x="5" y="5" width="10" height="10" rx="1" fill="currentColor" stroke="none" />
  </>
);

export const CursorIcon = svg(
  <>
    <path d="M5 3l5 14 2-6 6-2z" fill="currentColor" stroke="none" />
  </>
);

export const MaskIcon = svg(
  <>
    <rect x="3" y="3" width="14" height="14" rx="2" />
    <path d="M3 10h14" fill="currentColor" stroke="none" />
  </>
);

export const HideImageIcon = svg(
  <>
    <rect x="3" y="5" width="14" height="10" rx="1.5" />
    <circle cx="7.5" cy="9" r="1.2" />
    <path d="M17 5L3 15" />
  </>
);

export const KeyboardIcon = svg(
  <>
    <rect x="2.5" y="5" width="15" height="10" rx="1.5" />
    <path d="M5.5 8.5h.01" />
    <path d="M9 8.5h.01" />
    <path d="M12.5 8.5h.01" />
    <path d="M15 11.5H7" />
  </>
);

export const ResetIcon = svg(
  <>
    <path d="M3.5 10a6.5 6.5 0 106.5-6.5" />
    <path d="M3.5 4v3.5H7" />
  </>
);

export const CloseIcon = svg(
  <>
    <path d="M5 5l10 10" />
    <path d="M15 5L5 15" />
  </>
);

export const CheckIcon = svg(
  <>
    <path d="M4 10l4 4 8-8" />
  </>
);

const IconSet = {
  GlobeIcon, FocusIcon, LinkIcon, DyslexiaIcon, SpacingIcon, LineHeightIcon, WeightIcon,
  DarkContrastIcon, LightContrastIcon, HighContrastIcon, HighSatIcon, LowSatIcon, MonochromeIcon,
  ReadingGuideIcon, StopIcon, CursorIcon, MaskIcon, HideImageIcon, KeyboardIcon,
  ResetIcon, CloseIcon, CheckIcon,
};

export default IconSet;
